export const BASE_PATH =''; //BASE_PATH ='/new_site';  we must prefix '/' (but must no suffix '/') if it is not empty.